<template>
<div id="booking-widget">
    <div class="container bv-example-row content-body">
      <div class="row" v-if="this.errormsg !=''">
        <div class="col-md-12">
          <div class="alert alert-danger">
                <p>{{this.errormsg}}</p>
          </div>
        </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-4 col-4"></div>
            <div class="col-md-4 col-sm-4 col-4">
                <div class="loader" v-show="!pageloader">
                    <loader-terms></loader-terms>
                </div>
            </div>
            <div class="col-md-4 col-sm-4 col-4"></div>
        </div>
        <div class="row" v-show="pageloader && this.errormsg ==''">
            <div class="col-md-12 col-sm-12 col-12">
                <div class="row" style="margin-bottom:20px;">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 text-center">
                        <img :src="paymentDetails.logo" alt="">
                    </div>
                    <div class="col-md-4"></div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <!-- header for payment complete -->
                        <div v-if="paymentDetailsArray.length > 0">
                            <!-- if status is complete -->
                            <div v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'paid'">
                                <div class="text-center">
                                    <h2 class="text-center">
                                        <span>Thank you,</span> your booking has been confirmed. <br> <a @click="gotoMainWebsite(contactDetails.websiteURL)" style="cursor:pointer;">Go back To main website</a>
                                    </h2>
                                    <br />
                                </div>
                                <div class="text-center mrgb10">
                                    <a target="_blank" @click="print" class="btntop">
                                        Print confirmation
                                    </a>
                                </div>
                            </div>
                            <!-- if status is pending -->
                            <div v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'pending'">
                                <div id="pending">
                                    <div class="row">
                                        <div class="col-md-8" style="border-right:1px solid #F89224">
                                            <h4>PAYMENT PENDING</h4>
                                            <div id="thankyou">
                                                Thank you {{fullName}}.<br>
                                            </div>
                                            Your payment to <strong>{{paymentDetails.name}}</strong> is being processed. Once confirmed, you will receive an Email/SMS notification, and your payment settled instantly.Thank you for using PesaPal. <br> <br>
                                            <button class="btnb btn-large" @click="getPaymentDetailsReload()">check status</button>
                                            <!-- </div> -->
                                        </div>
                                        <div class="col-md-4">
                                            <h2 style="margin-top:18%; text-align: center;  font-weight: 600; line-height: 40px; "> Would you like to make the payment again? </h2>
                                            <button class="btnb btn-large" @click="gotoMainWebsite(contactDetails.websiteURL)">Click here to retry</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- if status is failed -->
                            <div v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'failed'">
                                <!--  -->
                                <div id="failed">
                                    <div class="row">
                                        <div class="col-md-8" style="border-right:1px solid #EED3D7">
                                            <h4 style="font-weight: 600">Payment Failed</h4>
                                            <div id="border-right" style="border-right: 2px dashed #333; padding: 0 15px 0 0">
                                                <p>We have noted your payment has failed. This could be because of several reasons;</p>
                                                <ol>
                                                    <li>The card details you entered are incorrect.</li>
                                                    <li>Your bank may have blocked online payments.</li>
                                                    <li>You have insufficient funds in the card/mobile money account you are attempting to use.</li>
                                                    <li>Your bank may have declined this transaction, kindly check with your bank.</li>
                                                </ol>

                                                <p>For further assistance, kindly contact us via email at <a :href="'mailto:' + contactDetails.alternativeEmail">{{contactDetails.alternativeEmail}}</a> / <a :href="'mailto:' + contactDetails.mainEmail">{{contactDetails.mainEmail}}</a> / <a href="mailto:helpdesk@pesapal.com">helpdesk@pesapal.com</a> or call us on {{contactDetails.phoneNumber}}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <h2 style="margin-top:18%; text-align: center;  font-weight: 600; line-height: 40px; ">Would you like to make the payment again? </h2>
                                            <button class="btnb btn-large" @click="gotoMainWebsite(contactDetails.websiteURL)"> Click here to retry</button>
                                        </div>

                                    </div>

                                </div>
                                <!--  -->
                            </div>
                        </div>
                        <!-- payment for pending status -->
                        <div v-if="paymentDetailsArray.length == 0">
                            <div id="pending">
                                <h4>PAYMENT PENDING</h4>
                                <div id="thankyou">
                                    Thank you {{fullName}}.<br>
                                </div>
                                Your payment to <strong>{{paymentDetails.name}}</strong> is being processed. Once confirmed, you will receive an Email/SMS notification, and your payment settled instantly.Thank you for using PesaPal. <br> <br>
                                <button class="btnb btn-large" @click="getPaymentDetailsReload()">check status</button>
                            </div>
                        </div>
                        <div class="text-center" style="margin: 0 auto; padding-top: 0.3em; padding-bottom: 0.3em">
                            <p>Your booking number is <span>{{paymentDetails.referenceNumber}}</span></p>
                        </div>
                        <p>
                            <span class="badge badge-info" style="
                    color: #fff;
                    font-size: 12px;
                    margin: 0 auto;
                    display: table;
                    padding: 0.5em 0.6em 0.3em 0.6em;
                  ">
                                Arrival: &nbsp;{{checkinDate}} &nbsp;&nbsp;&nbsp; Departure:
                                &nbsp;{{ checkoutDate }}
                            </span>
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <table id="room_details_1" class="table table-bordered table-striped">
                            <thead>
                                <th>{{roomLabel.singular}} details</th>
                                <th>Nights</th>
                                <th colspan="2">Guests</th>
                                <th style="position: relative">Meal Plan</th>
                                <th style="text-align: right">Total</th>
                            </thead>
                            <!-- if multiroom -->
                            <tbody>
                                <tr v-for="(mroom, index) in rooms" :key="index">
                                    <td>{{ mroom.name }}</td>
                                    <td>{{night}}</td>
                                    <td colspan="2"><span>{{mroom.adults}} adult</span> &nbsp;<span v-if="mroom.children > 0">{{mroom.children}} children</span>&nbsp;<span v-if="mroom.babies > 0">{{mroom.babies}} babies</span></td>
                                    <td valign="middle"><span v-if="mroom.meal_plan !=''">{{mroom.meal_plan}}</span> <span v-else>N/A</span></td>
                                    <td valign="middle" style="text-align: right">
                                        {{paymentDetails.currency}} {{ formatPrice(mroom.price) }}
                                    </td>
                                </tr>
                            </tbody>
                            <!-- end -->
                        </table>
                        <div v-if="enhancements.length !=0">
                            <div class="enh-head">
                                <div class="row">
                                    <div class="col-md-12">Enhancements</div>
                                </div>
                            </div>
                            <div class="row enhancements" v-for="(adhance, index) in enhancements" :key="index">
                                <div class="col-md-6 paddt5 paddb5 paddl5">
                                    {{ adhance.name }}
                                </div>
                                <div class="col-md-3 paddt5 paddb5 text-left">
                                    <strong>Qnty:</strong>
                                </div>
                                <div class="col-md-3 paddt5 paddb5 paddr5 text-right">
                                    {{paymentDetails.currency}} {{ formatPrice(adhance.price) }}
                                </div>
                            </div>
                        </div>
                        <div class="clear clearfix paddtb5"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-7"></div>
                    <div class="col-md-5 paddborder0">
                        <div class="block mrgt15">
                            <table id="priceSum" class="table table-bordered pull-right mrgb10" style="max-width: 350px">
                                <tbody>
                                    <tr>
                                        <td class="pricelabel">Subtotal:</td>
                                        <td id="finalPrice">
                                            <div id="sub-total">{{paymentDetails.currency}} {{formatPrice(paymentDetails.subTotal)}}</div>
                                        </td>
                                    </tr>
                                    <tr v-if="paymentDetails.totalDiscount !=0">
                                        <td class="pricelabel">Discount:</td>
                                        <td id="finalPrice">
                                            <div id="sub-total">{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalDiscount)}}</div>
                                        </td>
                                    </tr>
                                    <tr v-if="paymentDetails.totalServiceCharge > 0">
                                        <td class="pricelabel">Service Charges:</td>
                                        <td id="finalPrice">
                                            <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalServiceCharge)}}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="paymentDetails.totalVAT > 0">
                                        <td class="pricelabel">Total VAT ({{formatPrice(vat.value)}} %)</td>
                                        <td id="finalPrice">
                                            <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalVAT)}} </span>
                                        </td>
                                    </tr>

                                    <tr v-if="paymentDetails.totalHotelTax > 0">
                                        <td class="pricelabel">{{hotelTax}}:</td>
                                        <td id="finalPrice">
                                            {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalHotelTax)}}
                                        </td>
                                    </tr>
                                    <tr v-if="paymentDetails.totalBalance ==0">
                                        <td class="pricelabel"><span>Amount Paid</span></td>
                                        <td id="finalPrice">
                                            <div>
                                                <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalAmountPaid)}}</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="paymentDetails.totalAmountPaid > 0 ">
                                        <td class="pricelabel">Deposit Paid:</td>
                                        <td id="finalPrice">
                                            <div>
                                                <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalAmountPaid)}}</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="paymentDetails.totalBalance >0">
                                        <td class="pricelabel">Pending Amount:</td>
                                        <td id="finalPrice">
                                            <div>
                                                <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalBalance)}}</span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="statuslabel">Status</td>
                                        <td id="finalPrice">
                                            <div id="paymentStatus" v-if="paymentDetailsArray.length > 0 ">
                                                <span class="status status_paid" v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'paid' && paymentDetails.totalBalance >0">Partially Paid </span>
                                                <span class="status status_paid" v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'paid' && paymentDetails.totalBalance ==0">Paid </span>
                                                <span class="status status_failed" v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'failed'">Failed</span>
                                                <span class="status status_paid" v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'pending'">PENDING</span>
                                            </div>
                                            <div id="paymentStatus" v-else>
                                                <span class="status status_paid">PENDING</span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="pricelabel">Payment Method:</td>
                                        <td id="finalPrice">
                                            <div v-if="paymentDetailsArray.length > 0 ">{{paymentDetails.payment_details[0].payment_method}}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="clear clearfix paddtb5"></div>
                </div>
                <hr />
                <div v-if="paymentDetailsArray.length > 0 ">
                    <div class="row" v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'pending'">
                        <div class="col-md-6 col-sm-6">
                            <div class="whatnext">
                                <h3>What Next?</h3>
                                <p>Your reservation has been placed successfully. Please note that we cannot fully confirm your booking until payment received.</p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="text-center share-complete" style="max-width: 350px; margin: 10px auto; display: table">
                                <h3>Share this with friends</h3>
                                <strong>Let your friends know you made a booking online</strong>
                                <div class="icon-share text-center">
                                    <a target="_blank" class="fb" v-if="contactDetails.facebookPage !=''" :href="contactDetails.facebookPage">
                                        <i class="fa fa-facebook"></i>
                                    </a>
                                    <a class="fb" v-else href="javascript:void(0)">
                                        <i class="fa fa-facebook"></i>
                                    </a>

                                    <a target="_blank" class="tw" v-if="contactDetails.twitterHandle !=''" :href="contactDetails.twitterHandle">
                                        <i class="fa fa-twitter"></i>
                                    </a>
                                    <a class="tw" v-else href="javascript:void(0)">
                                        <i class="fa fa-twitter"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-md-12">
                            <div class="text-center share-complete" style="max-width: 350px; margin: 10px auto; display: table">
                                <h3>Share this with friends</h3>
                                <strong>Let your friends know you made a booking online</strong>
                                <div class="icon-share text-center">
                                    <a target="_blank" class="fb" v-if="contactDetails.facebookPage !=''" :href="contactDetails.facebookPage">
                                        <i class="fa fa-facebook"></i>
                                    </a>
                                    <a class="fb" v-else href="javascript:void(0)">
                                        <i class="fa fa-facebook"></i>
                                    </a>

                                    <a target="_blank" class="tw" v-if="contactDetails.twitterHandle !=''" :href="contactDetails.twitterHandle">
                                        <i class="fa fa-twitter"></i>
                                    </a>
                                    <a class="tw" v-else href="javascript:void(0)">
                                        <i class="fa fa-twitter"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- twh -->
        <div v-show="printpage" id="printMe">
            <table style="width:100%; margin:30px 0;">
                <tbody>
                    <tr>
                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:center;font-size:14px;">
                            <table id="receipt" style="max-width:680px; width: 100%; margin:0 auto; padding:15px 0; border:1px solid #DEDEDE; background:#FFF">
                                <tbody style="font-family:Arial,Helvetica,sans-serif;text-align:left;font-size:14px;">
                                    <tr>
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:center;font-size:14px; padding:15px 0">
                                            <img :alt="paymentDetails.name" :title="paymentDetails.name" :src="paymentDetails.logo">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:center;font-size:14px;">
                                            <h4><strong>Thank you, your booking has been confirmed.</strong></h4>
                                            <h4>Your booking number is <strong>{{paymentDetails.referenceNumber}}</strong>
                                            </h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:20px;font-size:14px;">
                                            Dear user {{fullName}},<br /><br />
                                            Thank you for making your booking at
                                            <strong>{{paymentDetails.name}}</strong>.<br /><br />
                                            Your booking has been successfully processed. Please do not hesitate to contact us should you require any further assistance.<br /><br />
                                            We look forward to welcoming you and wish you a most hospitable stay.<br /><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;">
                                            <table class="table" style="width:100%">
                                                <tbody>
                                                    <tr>
                                                        <td valign="top" style="padding:0; width: 49%; float:left; border-top: none">
                                                            <table style="width:100%; margin-bottom:15px; border: 1px solid #DEDEDE ">
                                                                <tbody>
                                                                    <tr>
                                                                        <td colspan="2" style="background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt;">
                                                                            <strong>Payment Details</strong>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="padding:5pt 10.0pt 0 10.0pt; min-width: 150px; min-width: 150px">
                                                                            <strong>Payment Ref: </strong>
                                                                        </td>
                                                                        <td style="padding:5pt 10.0pt 5pt 5pt">
                                                                            {{paymentDetails.referenceNumber}}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="padding:5pt 10.0pt 0 10.0pt; min-width: 150px">
                                                                            <strong>Payment Date: </strong>
                                                                        </td>
                                                                        <td style="padding:5pt 10.0pt 5pt 5pt">
                                                                            {{checkinDate}}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                            <strong>Payment Status: </strong>
                                                                        </td>
                                                                        <td style="padding:5pt 10.0pt 5pt 5pt">
                                                                            <div id="paymentStatus" v-if="paymentDetailsArray.length > 0 ">
                                                                                <span class="status status_paid" v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'paid' && paymentDetails.totalBalance >0">Partially Paid </span>
                                                                                <span class="status status_paid" v-if="paymentDetails.payment_details[0].status.toLowerCase() == 'paid' && paymentDetails.totalBalance ==0">Paid </span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                            <strong>Payment Method: </strong>
                                                                        </td>
                                                                        <td style="padding:5pt 10.0pt 5pt 5pt" v-if="paymentDetailsArray.length > 0">
                                                                            {{paymentDetails.payment_details[0].payment_method}}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                            <strong>
                                                                                Processed By: </strong>
                                                                        </td>
                                                                        <td style="padding:5pt 10.0pt 5pt 5pt">PesaPal</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td valign="top" style="padding:0; width:49%; float:right; border-top: none">
                                                            <table style="width:100%; border: 1px solid #DEDEDE">
                                                                <tbody>
                                                                    <tr>
                                                                        <td colspan="2" style="background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt;">
                                                                            <strong>Booking Details</strong>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                            <strong>Booking Ref: </strong>
                                                                        </td>
                                                                        <td style="padding:5pt 10.0pt 5pt 5pt;">
                                                                            {{paymentDetails.referenceNumber}}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                            <strong>Arrival date: </strong>
                                                                        </td>
                                                                        <td style="padding:5pt 10.0pt 5pt 5pt;">
                                                                            {{checkinDate}}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                            <strong>Arrival Time</strong>
                                                                        </td>
                                                                        <td style="padding:5pt 10.0pt 5pt 5pt;">
                                                                            {{arrivalTime}}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="padding:5pt 10.0pt 0 10.0pt">
                                                                            <strong> Departure date:</strong>
                                                                        </td>
                                                                        <td style="padding:5pt 10.0pt 5pt 5pt;">
                                                                            {{checkoutDate}}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;">
                                            <table id="room_details_1" class="table" style="width:100%; margin-bottom:15px">
                                                <thead>
                                                    <th style="background:#e5e5e5; border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;">{{roomLabel.singular}} details</th>
                                                    <th style="background:#e5e5e5; border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;">Nights</th>
                                                    <th colspan="2" style="background:#e5e5e5;  border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;">Guests</th>
                                                    <th style="background:#e5e5e5;  border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;">Meal Plan</th>
                                                    <th style="text-align:right; border-bottom:none; background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt;">Total</th>
                                                </thead>
                                                <!-- if multiroom -->
                                                <tbody>
                                                    <tr v-for="(mroom, index) in rooms" :key="index">
                                                        <td style="padding:3pt 10.0pt 3pt 10.0pt">{{ mroom.name }}</td>
                                                        <td style="padding:3pt 10.0pt 3pt 10.0pt">{{night}}</td>
                                                        <td colspan="2" style="padding:3pt 10.0pt 3pt 10.0pt"><span>{{mroom.adults}} adult</span> &nbsp;<span v-if="mroom.children > 0">{{mroom.children}} children</span>&nbsp;<span v-if="mroom.babies > 0">{{mroom.babies}} babies</span></td>
                                                        <td valign="middle" style="padding:3pt 10.0pt 3pt 10.0pt"><span v-if="mroom.meal_plan !=''">{{mroom.meal_plan}}</span> <span v-else>N/A</span></td>
                                                        <td valign="middle" style="text-align:right; padding:3pt 10.0pt 3pt 10.0pt">
                                                            {{paymentDetails.currency}} {{ formatPrice(mroom.price) }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <!-- end -->
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;" v-if="enhancements.length != 0">
                                            <table id="room_details_2" class="table" style="width:100%; margin-bottom:15px">
                                                <thead>
                                                    <th colspan="3" style="background:#e5e5e5; border-bottom:none; padding:3.0pt 10.0pt 3.0pt 10.0pt;"> Enhancements</th>
                                                </thead>
                                                <tbody v-for="(adhance, index) in enhancements" :key="index">
                                                    <tr>
                                                        <td style="padding:3pt 10.0pt 3pt 10.0pt; border-right:none">{{adhance.name}}</td>
                                                        <td style="padding:3pt 10.0pt 3pt 10.0pt; border-right:none">
                                                            <strong>Qnty:</strong>
                                                        </td>
                                                        <td style="text-align:right; padding:3pt 10.0pt 3pt 10.0pt">
                                                            {{paymentDetails.currency}} {{ formatPrice(adhance.price) }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding:0 20px;">
                                            <div style="display:block; width:100%; overflow:hidden">
                                                <table id="priceSum" class="table" style="max-width:350px; margin-bottom: 10px; border: 1px solid #DEDEDE; float: right">
                                                    <tbody>
                                                        <tr>
                                                            <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                                Subtotal:
                                                            </td>
                                                            <td align="right" style="padding:5px; min-width:150px">
                                                                <div id="sub-total">

                                                                    <div id="sub-total">{{paymentDetails.currency}} {{formatPrice(paymentDetails.subTotal)}}</div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="paymentDetails.totalDiscount >0">
                                                            <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                                Discount:
                                                            </td>
                                                            <td align="right">
                                                                <span> {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalDiscount)}} </span>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="paymentDetails.totalServiceCharge > 0">
                                                            <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                                Service Charges:
                                                            </td>
                                                            <td align="right">
                                                                <span> {{paymentDetails.currency}}{{ formatPrice(paymentDetails.totalServiceCharge) }} </span>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="paymentDetails.totalVAT > 0">
                                                            <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                                Total VAT ({{formatPrice(vat.value)}} %)
                                                            </td>
                                                            <td align="right" style="padding:5px; min-width:150px">
                                                                <span> {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalVAT)}} </span>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="paymentDetails.totalHotelTax > 0">
                                                            <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                                {{hotelTax}}:
                                                            </td>
                                                            <td align="right">
                                                                {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalHotelTax)}}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="extraCharges.gateway_fee_enabled ==1 && paymentDetails.totalGatewayFee > 0">
                                                            <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                                Gateway Fee:
                                                            </td>
                                                            <td align="right">
                                                                {{paymentDetails.currency}} {{formatPrice(paymentDetails.totalGatewayFee)}}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="paymentDetails.totalBalance ==0">
                                                            <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                                <span>Amount Paid</span>
                                                            </td>
                                                            <td align="right">
                                                                <div>
                                                                    <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalAmountPaid)}}</span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="paymentDetails.totalBalance >0">
                                                            <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                                Deposit Paid:
                                                            </td>
                                                            <td align="right">
                                                                <div>
                                                                    <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalAmountPaid)}}</span>
                                                                </div>
                                                            </td>

                                                        </tr>
                                                        <tr v-if="paymentDetails.totalBalance >0">
                                                            <td class="pricelabel" style="background: #eee; font-weight:600; padding:5px; min-width:150px;">
                                                                Pending Amount:
                                                            </td>
                                                            <td align="right">
                                                                <div>
                                                                    <span>{{paymentDetails.currency}} {{formatPrice(paymentDetails.totalBalance)}}</span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </td>
                                    </tr>
                                    <tr v-if="paymentDetails.terms !==''">
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;">
                                            <table class="table" style="width:100%; padding:3.0pt 10.0pt 3.0pt 0">
                                                <tbody>
                                                    <tr>
                                                        <td style="background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt">
                                                            <strong>Terms & Conditions</strong>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding:5pt 10.0pt 5pt 10pt">
                                                            <p v-html="paymentDetails.terms"></p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr v-if="paymentDetails.cancellation_policies !==''">
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 20px;font-size:14px;">
                                            <table class="table" style="width:100%; padding:3.0pt 10.0pt 3.0pt 0">
                                                <tbody>
                                                    <tr>
                                                        <td style="background:#e5e5e5;padding:3.0pt 10.0pt 3.0pt 10.0pt">
                                                            <strong>Cancellation Policies</strong>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding:5pt 10.0pt 5pt 10pt">
                                                            <p v-html="paymentDetails.cancellation_policies"></p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:0 25px 20px 25px;font-size:14px;">
                                            <strong>Sincerely,<br /></strong>
                                            e-Commerce,<br />
                                            {{paymentDetails.name}}

                                            <br />
                                            <br /><strong>Tel: </strong>{{contactDetails.phoneNumber}}<br /><strong>Email: </strong>{{contactDetails.mainEmail}} /{{contactDetails.alternativeEmail}}<br /> <strong>Website:</strong> {{contactDetails.websiteURL}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-family:Arial,Helvetica,sans-serif;text-align:left; padding:10px 25px 10px 25px;font-size:14px; border-top: 1px dotted #DEDEDE">
                                            <div style="display: block; text-align: center;">
                                                <strong>Powered by: </strong>
                                                <a href="http://www.reserveport.com" style="color: #df7042; font-size: 12px; display: inline-block;">Reserveport</a> &
                                                <a href="http://www.pesapal.com" style="color: #a81414; font-size: 12px; display: inline-block;"><span style="color: #1e62a6; display: inline-block">Pesa</span>Pal</a><br>
                                                &copy; 2014 - {{currentYear}}, all rights reserved.
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- kijkm -->
    </div>
</div>
</template>

<script>
import loader from '../components/loader.vue'
import reusableData from '../components/mixins/reusableData'
import moment from 'moment'
import { pushPlatformEvent, toAmount, groupRoomItems } from '../utils/ecommerce'

export default {
  name: 'App',
  components: {
    'loader-terms': loader
  },
  data () {
    return {
      chargeType: '',
      printpage: false,
      enhancementprice: 0,
      paymentDetails: {},
      propertyid: '', // this.$store.state.pid,
      referenceNumber: '',
      trackingID: '',
      night: 0,
      currentYear: '',
      fullName: '',
      occupancy: '',
      enhancements: '',
      checkinDate: '',
      checkoutDate: '',
      vat: '',
      rooms: '',
      hotelTax: '',
      contactDetails: '',
      extraCharges: '',
      arrivalTime: '',
      departureTime: '',
      pageloader: false,
      timeleft: 15,
      paymentDetailsArray: '',
      status: '',
      roomLabel: '',
      errormsg: '',
      consumerKey: '',
      secretKey: '',
      postUrl: '',
      ppKey: '',
      ppSecret: ''
    }
  },
  mounted () {
    var hash = document.location.hash
    var params = hash.split('?')[1]
    if (params && params !== '') {
      var paramresult = params.split('&').reduce(function (res, item) {
        const parts = item.split('=')
        res[parts[0]] = parts[1]
        return res
      }, {})
    }
    if (paramresult.OrderTrackingId !== undefined) {
      this.trackingID = paramresult.OrderTrackingId
      this.referenceNumber = paramresult.OrderMerchantReference
    } else if (this.getUrlParameter('pesapal_transaction_tracking_id') !== '') {
      this.trackingID = this.getUrlParameter('pesapal_transaction_tracking_id')
      this.referenceNumber = this.getUrlParameter('pesapal_merchant_reference')
    } else if (paramresult.PesapalTransactionTrackingId !== undefined) {
      this.trackingID = paramresult.PesapalTransactionTrackingId
      this.referenceNumber = ''
    } else if (paramresult.pesapal_transaction_tracking_id !== undefined) {
      this.trackingID = paramresult.pesapal_transaction_tracking_id
      this.referenceNumber = paramresult.pesapal_merchant_reference
    }
    // var pid = hash.split('?')[1]
    this.propertyid = paramresult.pid
    this.getPaymentDetails()
    this.currentYear = moment().format('YYYY')
    //  set interval method that getpayment data to check for status
    setTimeout(() => this.reFetchPaymentDetails(), 20000)
  },
  methods: {
          pushBookingDataToDataLayer(bookingData) {
        if (!window.dataLayer) {
            console.warn('dataLayer not initialized');
            return;
        }

        window.dataLayer.push({
            event: "booking_purchase",
            booking_id: bookingData.referenceNumber,
            hotel_name: bookingData.name,
            hotel_uid: bookingData.pid,
            booking_amount: parseFloat(bookingData.totalAmountPayable),
            checkout_date: this.formatDate(bookingData.occupancy.checkout_date),
            currency: bookingData.currency
        });

        // console.log('Booking data pushed to dataLayer:', {
        //     event: "booking_purchase",
        //     booking_id: bookingData.referenceNumber,
        //     hotel_name: bookingData.name,
        //     hotel_uid: bookingData.pid,
        //     booking_amount: parseFloat(bookingData.totalAmountPayable),
        //     checkout_date: this.formatDate(bookingData.occupancy.checkout_date),
        //     currency: bookingData.currency
        // });
    },
    pushPlatformPurchase (bookingData) {
        // getPaymentDetails re-runs while polling, so send purchase once per reference number
        const sentKey = 'reserveport_purchase_' + bookingData.referenceNumber
        try {
            if (sessionStorage.getItem(sentKey)) {
                return
            }
            sessionStorage.setItem(sentKey, '1')
        } catch (error) {
            // storage unavailable: fall through and send
        }
        pushPlatformEvent('purchase', {
            hotel_id: bookingData.pid,
            hotel_name: bookingData.name,
            currency: bookingData.currency,
            value: toAmount(bookingData.totalAmountPayable),
            transaction_id: bookingData.referenceNumber,
            items: groupRoomItems(bookingData.rooms)
        })
    },
    gotoMainWebsite (url) {
      if (!url.match(/^http?:\/\//i) || !url.match(/^https?:\/\//i)) {
        url = 'https://' + url
        window.location.replace(url)
      } else {
        window.location.replace(url)
      }
      //
    },
    print () {
      this.$htmlToPaper('printMe')
    },
    formatDate (dateString) {
        return new Date(dateString).toISOString().split('T')[0];
    },
    formatPrice (value) {
      if (isNaN(value)) {
        return value
      } else {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    reFetchPaymentDetails () {
      if (this.paymentDetails.payment_details.length > 0) {
        if (this.paymentDetails.payment_details[0].status.toLowerCase() === 'pending') {
          var setIntervaCalls = setInterval(() => this.getPaymentDetails(), 15000)
          //  stop intervalcalls after 3 minutes
          setTimeout(() => clearInterval(setIntervaCalls), 180000)
        }
      }
    },
    getPaymentDetailsReload () {
      location.reload()
    },
    async getPaymentDetails () {
      const configUrl = process.env.CONFIG_URL['live_url']
      const key = process.env.PMS_KEY['key']
      const config = {
        headers: { 'Accept': 'application/json' }
      }
      const payload = {
        'property_id': this.propertyid,
        'api': this.type
      }
      const configRes = await this.$http.post(configUrl, payload, config)
      if (configRes.status === 200) {
        let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
        configData = JSON.parse(configData)
        let passkey = configData[0].val_ptoken // process.env.SECRET_KEY[this.propertyid].key
        let consumerKey = configData[0].val_reserveport_secret_key // process.env.CONSUMER_KEY[this.propertyid].key
        const details = JSON.parse(configData[0].add_details)
        let postUrl = details.url
        const postData = {
          reference_number: this.referenceNumber,
          pesapal_merchant_reference: this.referenceNumber,
          pesapal_tracking_id: this.trackingID
        }
        var postDataJson = JSON.stringify(postData)
        var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
        var pesapalKey = this.ppKey // process.env.CONSUMER_PESAPAL_KEY[this.propertyid].key
        var pesapalSecret = this.ppSecret // process.env.CONSUMER_PESAPAL_SECRET[this.propertyid].secret
        //   var baseUrl = process.env.API_URL[this.propertyid].url
        var url = `${postUrl}index.php?option=com_goreserva_psearch&task=api.fetchReservation&pid=${this.propertyid}&pk=${pesapalKey}&ps=${pesapalSecret}&consumer_key=${consumerKey}&data=${encryptedData}`
        this.axios
          .get(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            let responseData = response.data.er
            let decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
            return JSON.parse(decryptedData)
          })
          .then((data) => {
            if (data.error) {
              this.errormsg = data.msg
              this.pageloader = true
            // let constDecrpyteErrorData = this.CryptoJSAesDecrypt(passkey, data.data)
            } else {
              this.paymentDetails = data
              this.roomLabel = data.room_label
              this.paymentDetailsArray = data.payment_details
              this.fullName = data.reservationFor.first_name + ' ' + data.reservationFor.last_name
              this.occupancy = data.occupancy
              this.enhancements = data.enhancements
              this.checkinDate = data.occupancy.checkin_date
              this.checkoutDate = data.occupancy.checkout_date
              this.arrivalTime = data.occupancy.arrival_time
              this.departureTime = data.occupancy.departure_time
              this.vat = data.vat
              this.hotelTax = data.extra_charges.hotel_tax.name
              this.extraCharges = data.extra_charges
              this.contactDetails = data.contactDetails
              this.rooms = data.rooms
              var date1 = new Date(this.paymentDetails.occupancy.checkin_date)
              var date2 = new Date(this.paymentDetails.occupancy.checkout_date)
              var DifferenceInTime = date2.getTime() - date1.getTime()
              this.night = DifferenceInTime / (1000 * 3600 * 24)
                // console.log('data payment details ' + JSON.stringify(this.paymentDetails));
                if (
                    Array.isArray(data.payment_details) &&
                    data.payment_details.length > 0 &&
                    typeof data.payment_details[0].status === 'string' &&
                    data.payment_details[0].status.toLowerCase() === 'paid'
                ) {
                    this.pushBookingDataToDataLayer(data);
                    this.pushPlatformPurchase(data);
                }
              this.pageloader = true
            }
          })
          .catch((error) => {
            console.log('error', error)
            this.isProcessing = false
          })
      }
    }
  },
  mixins: [reusableData]
}
</script>

<style scoped>
#finalPrice {
    text-align: right;
}

#placed {
    background: #d9edf7;
    border: 1px solid #bce8f1;
    color: #31708f;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 10px;
}

#failed a {
    color: #973E1C;
}

#failed {
    background: #F2DEDE;
    border: 1px solid #EED3D7;
    color: #B94A48;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 10px;
}

#failed h4,
#failed h4 {
    padding-top: 0;
    margin-top: 0;
    text-align: center;
    text-transform: uppercase;
}

#pending {

    background: #FEE9D4;
    border: 1px solid #f89224;
    color: #e1890b;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 10px;
}

#pending h4,
#placed h4 {
    padding-top: 0;
    margin-top: 0;
    text-align: center;
    text-transform: uppercase;
}

#thankyou {
    display: block;
    margin-bottom: 10px;
    font-weight: 600;
}

.btn-large {
    width: 100%;
    max-width: 350px;
    font-size: 17px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.btnb {
    text-transform: uppercase;
    font-weight: 500;
    font-size: 12px !important;
    padding: 6px 10px 5px 10px !important;
    background: #e1890b;
    border-color: #f89224;
    color: #fff;
    overflow: hidden;
    -moz-border-radius: 0px !important;
    -webkit-border-radius: 0px !important;
    -khtml-border-radius: 0px !important;
    border-radius: 0px !important;
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

h1,
.h1,
h2,
.h2,
h3,
.h3 {
    margin: 10px 0 10px 0;
    color: #333;
    font-weight: 300;
}

.btntop {
    border: none;
    padding: 6px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    border-radius: 4px;
    cursor: pointer;
    background: #28a745;
}

.mrgb10 a {
    color: white;
}

.icon-share a.fb {
    background: #2954a3;
    color: #fff;
}

.icon-share a.tw {
    background: #1db4c6;
    color: #fff;
}

.icon-share a.gp {
    background: #be430d;
    color: #fff;
}

.icon-share a.wa {
    background: #129431;
    color: #fff;
}

.icon-share a {
    display: inline-block;
    padding: 8px 5px;
    margin: 0 0 0 5px;
    min-width: 32px;
    text-align: center;
}

.block,
.btn-book {
    display: block;
    overflow: hidden;
}

.mrgt15 {
    margin-top: 15px;
}

#priceSum tr,
#priceSum td {
    padding-top: 5px;
    padding-bottom: 5px;
}

.pricelabel {
    text-align: left !important;
    font-size: 10px;
    text-transform: uppercase;
    white-space: nowrap;
    font-weight: 600;
}

.table td.pricelabel,
.table td.statuslabel {
    text-align: right !important;
    font-size: 10px;
    text-transform: uppercase;
    background: #eee;
    white-space: nowrap;
    font-weight: 600;
}

.enhancements {
    border: 1px solid #dcdcdc;
    border-top: none;
    margin: 0;
    position: relative;
    overflow: hidden;
    padding-bottom: 15px;
}

.enh-head,
.summary-head {
    background: #e9e9e9;
    color: #000;
    font-weight: bold;
    padding: 5px;
    border: 1px solid #dcdcdc;
}

.table th {
    border-bottom: 1px solid #dcdcdc;
    border-left: 0px solid #dcdcdc !important;
    border-right: 0px solid #dcdcdc !important;
    background: #e9e9e9;
    padding: 5px;
}

.table td {
    border-bottom: 1px solid #dcdcdc;
    background: #F9F9F9;
    border-left: 0px solid #dcdcdc !important;
    border-right: 0px solid #dcdcdc !important;
}

.content-body {
    margin-top: 5em;
    margin-bottom: 5em;
    font-size: 0.9em !important;
}

.slide-fade-enter-active {
    transition: all 0.1s ease;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/paymentComplete.vue